import { getClientId } from '~/utils/hostHelper';
import * as jwtDecoder from 'jwt-decode';
import type { User } from '#auth-utils';

export const useAuth = () => {

  const { $api } = useNuxtApp();

  const showOnboarding = useLocalState<boolean>('showOnboarding', () => false);

  const updateLocale = (locale: string) => {
    const formData = new FormData();
    formData.append('locale', locale);
    $api<User>('users/current/locale', { method: 'POST', body: formData });
  };

  const updateCountry = (countryCode: string) => {
    const formData = new FormData();
    formData.append('countryCode', countryCode);
    $api<User>('users/current/country', { method: 'POST', body: formData });
  };

  const setShowOnboarding = (theShowOnboarding: boolean) => {
    showOnboarding.value = theShowOnboarding;
  };

  function tokenIsExpired(token: string): boolean {
    const decodedToken = jwtDecoder.jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp ? decodedToken.exp < currentTime : false;
  }

  function tokenExpiresIn(token?: string): number | null {
    if (!token) return null;
    const decodedToken = jwtDecoder.jwtDecode(token);
    return decodedToken.exp ? decodedToken.exp * 1000 - Date.now() : null;
  }

  return {
    updateLocale,
    updateCountry,
    showOnboarding,
    setShowOnboarding,
    tokenIsExpired,
    tokenExpiresIn
  };
};
